import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    ListarPorId: async (pId: number) => {
        const response = await httpClient.get(`/Atendimento/ProcedimentoListar?pIdAtendimento=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (pObj: any) => {
        const response = await httpClient.post(`/Atendimento/ProcedimentoInserir`, pObj);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (pObj: any) => {
        const response = await httpClient.post(`/Atendimento/ProcedimentoEditar`, pObj);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pIdAtendimento: number, pItem: number) => {
        const response = await httpClient.post(`/Atendimento/ProcedimentoExcluir?pIdAtendimento=${pIdAtendimento}&pItem=${pItem}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },

});